import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { BrnService } from '../../services/brn.service';

@Component({
  selector: 'app-slack-oauth',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './slack-oauth.component.html',
  styleUrls: ['./slack-oauth.component.scss']
})
export class SlackOauthComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private brnService: BrnService
  ) { }

  async ngOnInit(): Promise<void> {
    // Grab URL parameters: code and state
    const code = this.route.snapshot.queryParamMap.get('code');
    const state = this.route.snapshot.queryParamMap.get('state'); // This is the botId
    
    console.log('Slack OAuth code:', code);
    console.log('Slack OAuth state (botId):', state);
    
    if (code && state) {
      await this.authorizeSlack(code, state);
    } else {
      console.error('Missing code or state parameter');
    }
  }

  private async authorizeSlack(code: string, botId: string): Promise<void> {
    try {
      console.log('Authorizing Slack service...');
      const response = await firstValueFrom(this.brnService.authorizeSlackService(botId, code));
      
      if (response.status && response.client) {
        console.log('Slack authorization successful!', response.client);
        
        // Save client_id to the tool
        await this.updateToolWithClientId(botId, response.client.client_id);
      } else {
        console.error('Slack authorization failed');
      }
    } catch (error: any) {
      console.error('Error authorizing Slack service:', error);
    }
  }

  private async updateToolWithClientId(botId: string, clientId: string): Promise<void> {
    try {
      console.log('Updating tool with client_id:', clientId);
      const updateResponse = await firstValueFrom(
        this.brnService.updateTool(botId, { 
          channels: { 
            slack: { 
              client_id: clientId 
            } 
          } 
        })
      );
      
      if (updateResponse.status) {
        console.log('Tool updated successfully with Slack client_id');
        // Redirect to store page
        this.router.navigate(['/store', botId]);
      } else {
        console.error('Failed to update tool with client_id');
      }
    } catch (error: any) {
      console.error('Error updating tool with client_id:', error);
    }
  }

} 